<template>

    <v-section name="Links" :expanded="expanded">
        <v-action :name="item.name" v-for="item in items" :key="item.name">
            <v-input class="mb-5" size="sm" placeholder="https://" :model="item.link" @input="onInput(item, 'link', $event)" />
            <v-checkbox label="Visible" :model="item.display === 'none' ? false : true" @input="onInput(item, 'display', $event)"></v-checkbox>
        </v-action>
    </v-section>

</template>

<script>

import Action from './../actions/Action';
import Section from './Section';

export default {

    components: {
        'v-action': Action,
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        items() {
            return this.block.items;
        },

    },

    methods: {

        onInput(item, key, value) {
            let block = this.block;
            if (key === 'display') {
                block.items.forEach(i => {
                    if (i.name === item.name) {
                        i[key] = value ? 'inline-block' : 'none';
                    }
                });
            } else {
                block.items.forEach(i => {
                    if (i.name === item.name) {
                        i[key] = value;
                    }
                });
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>